import {isFeatureEnabled} from '@github-ui/feature-flags'
import {PullRequestState} from '../../types'
import {isPullRequestOpenState} from '../../utils/pull-request-state'

/**
 * Determines if a pull request is in a reviewable state.
 * Open states are: OPEN, DRAFT, and QUEUED.
 * If the pull_request_review_after_merged feature flag is enabled, MERGED is also considered reviewable.
 * Closed and archived PRs are considered non-reviewable.
 *
 * Review after merged is a feature that allows users to submit reviews on pull requests that have already been merged.
 * Users have indicated value in retroactive reviews as signals of confidence in the code that was merged.
 */
export function isReviewablePullRequestState(state: PullRequestState) {
  const isReviewWhenMergedEnabled = isFeatureEnabled('pull_request_review_after_merged')
  const prIsOpen = isPullRequestOpenState(state)

  return prIsOpen || (isReviewWhenMergedEnabled && state === PullRequestState.Merged)
}
